import { ChangeEvent, FocusEvent } from 'react';
import { FormFieldData } from '../../shared/form';

type RenameDeviceGroupData = {
  name: string;
};

export type RenameDeviceGroupFormData = FormFieldData<RenameDeviceGroupData>;

export type RenameDeviceGroupFormChangeEvent = ChangeEvent<
  HTMLInputElement | HTMLSelectElement
>;

export type RenameDeviceGroupFormBlurEvent = FocusEvent<
  HTMLInputElement | HTMLSelectElement,
  Element
>;

export const initialFormData: RenameDeviceGroupFormData = {
  name: {
    value: '',
    touched: false,
    error: null,
  },
};

export const validateDeviceGroupName = (value: string) => {
  if (!value.trim()) {
    return 'Please provide the new device group name';
  }

  return null;
};

export const validateForm = {
  name: validateDeviceGroupName,
};
